import clsx from 'clsx'
import { Button, ButtonProps } from 'react-daisyui'

const classes = clsx([
  'btn',
  'bg-white',
  'hover:bg-white',
  'hover:shadow-md',
  'border-1',
  'hover:border-curitec-orange',
  'border-curitec-orange',
  'text-curitec-green',
  'hover:text-curitec-orange',
  'w-full',
  'sm:w-auto'
])

type CuritecButtonProps = ButtonProps

const CuritecButton = (props: CuritecButtonProps) => {
  return (
    <Button
      className={clsx(classes, props.className)}
      {...props}
    />
  )
}

export default CuritecButton
